import { render } from "./multiple.vue?vue&type=template&id=8ae611ea&scoped=true&ts=true&lang=pug"
import script from "./multiple.vue?vue&type=script&lang=ts"
export * from "./multiple.vue?vue&type=script&lang=ts"

import "./multiple.vue?vue&type=style&index=0&id=8ae611ea&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ae611ea"]])

export default __exports__